<template>
    <div class="con">
        <div class="cons" :class="productType=='DFVIP'?'current':''">
			<div class="over-title">OverDue</div>
			<div class="title" v-text="productType=='DFVIP'?'DF.VIP':'Funpera'"></div>
			<div class="bot-con">
				<div class="bot-opt">
					<div class="date">Due Date：</div>
					<span>{{showDate()}}</span>
				</div>
				<a class="bot-a1" @click="repay" :class="productType=='DFVIP'?'active':''">Repay now</a>
			</div>
			
			<div class="bot-con">
				<div class="bot-opt">
					<div class="date">Repayment Amount：</div>
					<span>PHP {{onTheWayOrder.outstandingBalance}}</span>
				</div>
				<a class="bot-a2" @click="iShowExtend=true" v-if='!(overdueDays > 3) && productType != "DFEP"'>Extension</a>
			</div>
        </div>
		<extend-period v-if="iShowExtend" @back="iShowExtend=false" :id="orderId" :repayChannel="repaymentChannel" :withdrawChannel='withdrawChannel'></extend-period>
    </div>
</template>

<script>
	import ExtendPeriod from "@components/extendPeriod";
export default{
    data(){
        return {
			iShowExtend:false,
			orderId: this.onTheWayOrder.orderId,
			repaymentChannel: this.onTheWayOrder.repaymentChannel,
			extendServiceFee: this.onTheWayOrder.outstandingBalance,
			contractNumber: this.onTheWayOrder.contractNumber,
			dueDate: this.onTheWayOrder.dueDate,
			overdueDays:this.onTheWayOrder.overdueDays,
			withdrawChannel:this.onTheWayOrder.withdrawChannel
        }
    },
	props:{
		onTheWayOrder:{
			type:Object,
			default:()=>{}
		},
		productType:{
			type:String,
			default:""
		}
	},
    mounted: function() {
        var self = this;
    },
    methods:{
		repay(){
			let self = this;
			if(self.repaymentChannel == 1){
				location.href = './skypay.html?orderId='+ self.orderId +'&extendServiceFee='+ self.extendServiceFee +'&contractNumber='+ self.contractNumber +'&dueDate='+ self.dueDate + '&withdrawChannel='+self.withdrawChannel;
			}else{
				location.href =`./repayment.html?orderId=${self.orderId}&productType=${self.productType}`
			}
		},
		showDate(){
			const date = this.onTheWayOrder?.dueDate?.slice(0,10);
			if(date){
				return this.UTILS.dateFormatMatch(date)
			}
			else{
				return ""
			}
		}
    },
	
	components:{
		ExtendPeriod
	}
}
</script>

<style scoped>
.con{margin-bottom: 0.3rem;}
.cons{ width: 7rem;border-radius: 0.16rem; box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1); margin: 0 auto;color: #FF8F1F;background: #fff;}
.current{color:#667FFB}
.cons .title{padding: 0.2rem 0.3rem 0 0.3rem;font-size: 0.5rem; font-weight: bolder;} 
.cons .over-title{display: inline-block;float: right;padding: 0.04rem 0.4rem;font-size: 0.26rem;color: #fff;background: #FA0404;}
.bot-con{display: flex;align-items: center;justify-content: space-between;height: 0.94rem;padding: 0 0.3rem;}
.bot-opt{ display: flex;align-items: center;text-align: center;}
.bot-opt .date{ line-height: 0.4rem; font-size: 0.26rem; font-weight: bold;}
.bot-opt span{ line-height: 0.44rem; font-size: 0.26rem;font-weight: bold;}
.bot-a1{padding: 0 0.5rem;height: 0.8rem; line-height: 0.8rem; text-align: center; font-size: 0.30rem; color: #FFF; background-color: #ED7D31; border-radius: 0.2rem; box-shadow: 0px 3px 15px rgba(104, 141, 254, 0.39); display: block; }
.bot-a2{height: 0.9rem; line-height: 0.9rem; text-align: center; font-size: 0.32rem; color: #040507; display: block;}
.active{background-color:#667FFB}
</style>
